import * as yup from 'yup';
import { Create_Edit_UserFormValidation } from '../../Users/Create_Edit_User/Create_Edit_UserFormValidation';

export const LoanFormValidation = yup.object().shape({
    idBook: yup.string().required('Selecione o livro'),
    idUser: yup.string().required(),
    loanDate: yup.string().required('Data é obrigatória')
    .test('is-date', 'Data inválida', (value) => !value || !isNaN(Date.parse(value)))
    .test('is-past', 'Data não pode ser no futuro',
      (value) => !value || new Date(value) <= new Date()),
});